// components/providers/ClientProviders.tsx
"use client";

import { SessionProvider } from "next-auth/react";


export default function ClientProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <SessionProvider>
      {/* <ThemeProvider> */}
      {children}
      {/* </ThemeProvider> */}
    </SessionProvider>
  );
}
